import React, { useState, useEffect } from "react";
import RiseLoader from "react-spinners/RiseLoader";
import "./App.css";
import NavBar from "./components/NavBar/NavBar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Skills from "./components/Skills/Skills";
import Portfolio from "./components/Portfolio/Portfolio";
import Contact from "./components/Contact/Contact";
import Resume from "./components/Resume/Resume";
import Footer from "./components/Footer/footer";

function App() {
  let [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  return (
    <div>
      {loading ? (
        <div className="loader-container">
          <RiseLoader
            color={"#2f004f"}
            loading={loading}
            height={50}
            width={30}
            data-testid="loader"
            className="loader"
          />
        </div>
      ) : (
        <div>
          <NavBar />
          <Home />
          <About />
          <Skills />
          <Resume />
          <Portfolio />
          <Contact />
          <Footer />
        </div>
      )}
    </div>
  );
}

export default App;
